import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'

// utils
import { NotinoLabelRegular400, NotinoLabelSmall400 } from '../../styles/helpers'

// Price filter
export const PriceFieldWrapper = styled.div``

export const PriceInputsWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding-bottom: 12px;
`

export const PriceInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 4px;
	flex: 1 1 50%;
`

export const SecondaryPrice = styled.span`
	color: ${theme.color.text.tertiary};
	${NotinoLabelRegular400};
`

export const PriceInputDivider = styled.span`
	${NotinoLabelSmall400};
	color: #666;
`
